import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import { ChainOfCustodyReportEntry } from '../../../types/packager-types';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

interface PackagerChainOfCustodyReportTableProps {
  reportData: ChainOfCustodyReportEntry[];
}

const PackagerChainOfCustodyReportTable: React.FC<PackagerChainOfCustodyReportTableProps> = ({
  reportData,
}) => {
  // Generate columns from the reportData
  const columnDefs: ColDef<ChainOfCustodyReportEntry>[] = React.useMemo(() => {
    if (reportData.length === 0) return [];

    // Get all unique keys from the data
    const allKeys = new Set<keyof ChainOfCustodyReportEntry>();
    reportData.forEach((row) => {
      (Object.keys(row) as Array<keyof ChainOfCustodyReportEntry>).forEach((key) =>
        allKeys.add(key)
      );
    });

    // Convert keys to column definitions
    return Array.from(allKeys).map((key) => ({
      field: key,
      headerName: key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()),
      width: 150,
      sortable: true,
      filter: true,
      type: typeof reportData[0][key] === 'number' ? 'numericColumn' : undefined,
    }));
  }, [reportData]);

  const defaultColDef = React.useMemo(
    () => ({
      resizable: true,
      filter: 'agSetColumnFilter',
      sortable: true,
    }),
    []
  );

  const gridOptions = React.useMemo(
    () => ({
      pagination: true,
      paginationPageSize: 25,
      paginationPageSizeSelector: [10, 25, 50, 100],
    }),
    []
  );

  return (
    <Box>
      <Box sx={{ height: '500px', width: '100%' }}>
        <div className="ag-theme-balham" style={{ height: '100%', width: '100%' }}>
          <AgGridReact
            rowData={reportData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            gridOptions={gridOptions}
            suppressNoRowsOverlay={false}
            suppressPropertyNamesCheck={true}
            suppressMaintainUnsortedOrder={true}
            alwaysShowHorizontalScroll={true}
            tooltipShowDelay={700}
          />
        </div>
      </Box>
    </Box>
  );
};

export default PackagerChainOfCustodyReportTable;
